import { jsx } from 'react/jsx-runtime';

/**
 * Spazio che riempie un vuoto da utilizzare in un Application.Header.
 * Tipicamente utilizzato tra i componenti da mostrare a destra e quelli da mostrare a sinistra.
 */
function Gap({ grow = 1 }) {
    return (jsx("div", { style: { display: 'flex', flexGrow: grow } }));
}
Gap.displayName = 'Application.Gap';

export { Gap as default };
